import React from 'react';
import './footer.css';
import { useTranslation } from 'react-i18next';

const Footer = ({ setSelectedPage }) => {
    const { t, i18n } = useTranslation('footer');

    return (
        <footer className="footer">

            <div className="footer__policies">
                <span onClick={() => setSelectedPage(5)}>{t('aviso_legal')}</span>
                <span onClick={() => setSelectedPage(6)}>{t('politica_privacidad')}</span>
                <span onClick={() => setSelectedPage(7)}>{t('politica_cookies')}</span>
            </div>

            <div className="footer__info">
                <span>952 46 16 69 - 695 58 32 40</span>
                <span>gortzfernandezquiro@gmail.com</span>
                <span>FUENGIROLA - C/ BLANCA PALOMA 7, LOCAL 2</span>
                <span>MÁLAGA – C/ FERNANDO CAMINO 11, 1 A</span>
            </div>

        </footer>
    );
};

export default Footer;
